import styled from "styled-components";

export const StyledSidebar = styled.div`
  width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledSidebarIcon = styled.img`
  height: 25px;
  aspect-ratio: 1;
  margin: auto;
`;

export const StyledBanner = styled.img`
  width: 100%;
  user-select: none;
  cursor: pointer;
  box-shadow: 0 5px 10px -5px ${(p) => p.theme.shadow};
`;

export const StyledSocialsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
`;

export const StyledSocialIconWrapper = styled.div`
  padding: 14px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 100ms ease;
  cursor: pointer;
  &:hover,
  &:focus {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const StyledNavigation = styled.div``;
export const StyledFooter = styled.div``;

export const StyledProfileContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledProfileDetails = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  padding: 8px 0px 8px 8px;
  flex: 1;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const StyledAvatar = styled.span`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #47a025;
`;

export const StyledLogoutIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 8px 10px;
  border-left: 1px solid rgba(0, 0, 0, 0.12);

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const StyledDarkThemeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
`;
